import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { HudIcon, IconType } from '../Icons/HudIcons';
import { themeColor } from '../theme/colors';
import { smBold } from '../theme/typography';

export interface EmptyStateProps {
  title?: string | ReactNode;
  icon?: IconType;
  expanded?: boolean;
}

export function TableEmptyState({
  title = 'Nothing to see here yet',
  icon,
  expanded,
  ...rest
}: EmptyStateProps) {
  if (expanded && !icon) {
    icon = 'other.codeBrackets'
  }
  const iconSize = expanded ? '70px' : '40px';

  return (
    <EmptyStateContainer $expanded={expanded} {...rest}>
      {icon && <HudIcon icon={icon} size={iconSize} />}
      <Title>{title}</Title>
    </EmptyStateContainer>
  );
}

const EmptyStateContainer = styled.div<{ $expanded?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100px;

  & svg {
    color: ${themeColor('gray')};
  }

  ${({ $expanded }) =>
    $expanded &&
    css`
      height: unset;
      padding: 40px 0;
      flex-direction: column;
    `}
`;

const Title = styled.div`
  color: ${themeColor('textPrimary')};
  ${smBold}
  opacity: 0.8;
`;
